import { useEffect, useState } from 'react';
import { Col, Card, CardBody, CardHeader, CardFooter, Table, Row, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { H6, H5, Btn } from 'AbstractElements';
import CourseAttachMateriModal from './CourseAttachMateriModal';
// import { detachTryout } from 'Features/Learning/Tryout/Utils/TryoutUtils';
import { handleDetach } from 'Component/Learning/Courses/CoursesUtils';
import { setId, setMaterials } from 'Features/Learning/Courses/attachDetachCourseSlice';
import { attachDetachCourses, fetchCourses } from 'Features/Learning/Courses/Utils/CoursesUtils';
import { setDetail } from 'Features/Learning/Courses/courseSlice';
import { fetchMateri, handleBackPagination, handleClickPagination, handleNextPagination } from 'Component/Learning/Materi/MateriUtils';
import RawComponent from 'Component/Learning/Common/RawHTML';
import CleanLimitHTML from 'Component/Learning/Common/GenerateContent/CleanLimitHtml';
import GenerateUniqueContain from 'Component/Learning/Common/GenerateUnique';
import DualListBox from 'Component/Learning/Common/DualListBox';
import { handleGetDetailMaterial, handleEditMateri } from 'Component/Learning/Materi/MateriUtils';
import { setField as setFieldMateri } from 'Features/Learning/Materi/addMaterialSlice';
import { setDetail as setDetailMateri, setFilters } from 'Features/Learning/Materi/materialSlice';
import Moment from 'moment';
import 'moment/locale/id';
import Swal from 'sweetalert2';

const BoxListCourseDetail = () => {
	const dispatch = useDispatch();
	const detail = useSelector(state => state.Course.detail);
	const filter = useSelector(state => state.Course.filters);
	const filtersMateri = useSelector(state => state.Material.filters);
	const materiList = useSelector(state => state.Material.data.data);
	const materiPagination = useSelector(state => state.Material.data.pagination);
	const isLoadingMateri = useSelector(state => state.Material.isLoading);
	const data = useSelector(state => state.attachDetachCourse);
	// const dataOptions = useSelector(state => state.Material.data);
	const [modal, setModal] = useState(false);
	const [selectedAttachItems, setSelectedAttachItems] = useState([]);
	const [selectedAttachIds, setSelectedAttachIds] = useState([]);
	const [selectedMaterials, setSelectedMaterials] = useState([]);
	const [refetch, setRefetch] = useState(false);
	const filteredIds = detail.materials ? detail.materials.filter(material => !selectedMaterials.includes(material.id)) : [];
	const formatCombinedIds = Array.from(filteredIds).map(materialSelect => ({ value: materialSelect.id }));

	useEffect(() => {
		dispatch(setId(detail.id))
		// fetchMateri(dispatch)
		window.scrollTo(0, 0);
	}, [detail.id, dispatch])

	useEffect(() => {
		// sync data list materi untuk modal attach
		fetchMateri(dispatch, filtersMateri, refetch);
	}, [dispatch, filtersMateri, refetch])

	// helper reset untuk pilihan attach
	const resetAttachSelection = (items = []) => {
		const itemsArr = Array.isArray(items) ? items : [];
		setSelectedAttachItems(itemsArr);
		setSelectedAttachIds(itemsArr.map(item => item.id));
	};

	const handleCheckboxChange = (materialId) => {
		console.log(materialId, 'materialId')
		if (selectedMaterials.includes(materialId)) {
			// Jika sudah ada, hapus dari selectedMaterials
			setSelectedMaterials(selectedMaterials.filter((id) => id !== materialId));
			// dispatch(setMaterials(formatCombinedIds));
		} else {
			// Jika belum ada, tambahkan ke selectedMaterials
			setSelectedMaterials([...selectedMaterials, materialId]);
			// dispatch(setMaterials(formatCombinedIds));
			// console.log('combinedIds', combinedIds)
		}
		// console.log(questionId, 'questionId')
		// const newDetail = { ...detail };
		// newDetail.question = newDetail.question.filter((question) => question.id !== questionId);
		// dispatch(setDetail(newDetail));
	};

	const toggle = async () => {
		const initialIds = (detail.materials || []).map(item => item.id).sort().join(',');
		const currentIds = (selectedAttachIds || []).slice().sort().join(',');

		if (modal) {
			// konfirmasi jika ada perubahan yang belum disimpan
			if (initialIds !== currentIds) {
				const result = await Swal.fire({
					title: 'Apakah anda yakin?',
					text: 'Perubahan yang belum disimpan akan dibatalkan.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Ya',
					cancelButtonColor: '#d33',
				});

				if (!result.isConfirmed) return;
			}

			// reset dan tutup modal
			resetAttachSelection(detail.materials);
			setModal(false);
			return;
		}

		// buka modal: set id dan inisialisasi pilihan dari materi course
		dispatch(setId(detail.id));
		dispatch(setMaterials([]));
		resetAttachSelection(detail.materials);
		setModal(true);
	};

	const handleAttachCheckboxChange = (item) => {
		if (selectedAttachIds.includes(item.id)) {
			const newSelectedItems = selectedAttachItems.filter((value) => value.id !== item.id);
			const newSelectedIds = selectedAttachIds.filter((id) => id !== item.id);
			setSelectedAttachItems(newSelectedItems);
			setSelectedAttachIds(newSelectedIds);
		} else {
			setSelectedAttachItems([...selectedAttachItems, item]);
			setSelectedAttachIds([...selectedAttachIds, item.id]);
		}
	};

	const handleSearchClick = () => {
		// force reload data materi dengan filter terbaru
		const newFilters = {
			...filtersMateri,
			page: 1,
		};
		dispatch(setFilters(newFilters));
		setRefetch(prevRefetch => !prevRefetch);
	};

	const handleSubmit = async () => {
		// mapping selection menjadi format payload attach
		const uniqueMaterials = selectedAttachItems
			.filter((item, index, self) => self.findIndex((t) => t.id === item.id) === index)
			.map((item) => ({ value: item.id }));
		const payload = {
			id: detail.id,
			materials: uniqueMaterials,
		};

		try {
			const response = await dispatch(attachDetachCourses(payload));
			console.log('response:', response);
			// console.log('response.meta.arg.id:', response.meta.arg.id);
			// console.log('detailTryout:', detailTryout.id);
			if (response.payload === true) {
				setModal(false);
				const getCourses = await dispatch(fetchCourses({
					...filter,
					'filter[id]': detail.id,
				}));
				console.log('getCourses:', getCourses);
				// const questionData = getCourses.payload.data.filter(item => item.id === detail.id);
				// console.log('Sukses tutup modal:', questionData[0]);
				dispatch(setDetail(getCourses.payload.data[0]));
				// sync selection setelah sukses update
				resetAttachSelection(getCourses.payload.data[0]?.materials || []);
				Swal.fire(
					'Berhasil!',
					'Tambah materi ke course.',
					'success'
				)
			}
		} catch (error) {
			// Tanggapan error
			console.error('Error:', error);
			// Modal tidak akan ditutup jika terjadi kesalahan
		}
	};

	return (
		<>
			<Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
				<Card className="social-widget-card">
					<CardBody>
						<Col>
							<Row>
								<Col>
									<H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail.title || 'Title Course'}</H5>
								</Col>
								<Col className='text-end'>
									<H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>ID Course : {GenerateUniqueContain('CRS', detail.id, 5) || 'ID Course'}</H5>
								</Col>
							</Row>
						</Col>
						<Col>
							<H6 attrH6={{ className: 'font-roboto mt-4 font-primary' }}>{'Deskripsi Course'}</H6>
							<H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}><RawComponent htmlContent={detail.description || 'Description Course'} /></H5>
						</Col>
						<Col>
							<H6 attrH6={{ className: 'font-roboto mt-4 mb-3 font-primary' }}>{'Banner Course'}</H6>
							<div className="blog-page blog-box">
								<img style={{ width: "30%" }} src={detail.banner} alt={detail.title} />
							</div>
						</Col>
					</CardBody>
					<CardFooter>
						<Row>
							<Col>
								<div className="d-flex flex-column gap-2">
									<H6 attrH6={{ className: 'font-roboto' }}>Created at: {Moment(detail.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail.created_at).format('HH:mm:ss')} WIB</H6>
									<H6 attrH6={{ className: 'font-roboto' }}>Updated at: {Moment(detail.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail.updated_at).format('HH:mm:ss')} WIB</H6>
								</div>
							</Col>
							<Col className='text-end'>
								<Link to={`${process.env.PUBLIC_URL}/membership/course-list`}>
									<Btn attrBtn={{ color: 'warning', className: 'btn btn-primary m-r-10' }}>
										<i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
									</Btn>
								</Link>
								<CourseAttachMateriModal
									modal={modal}
									detail={detail}
									selectedAttachItems={selectedAttachItems}
									selectedAttachIds={selectedAttachIds}
									filtersMateri={filtersMateri}
									materiList={materiList}
									materiPagination={materiPagination}
									isLoadingMateri={isLoadingMateri}
									toggle={toggle}
									handleSubmit={handleSubmit}
									handleSearchClick={handleSearchClick}
									handleAttachCheckboxChange={handleAttachCheckboxChange}
									handleBackPagination={handleBackPagination}
									handleClickPagination={handleClickPagination}
									handleNextPagination={handleNextPagination}
									dispatch={dispatch}
									setFilters={setFilters}
									setRefetch={setRefetch}
								/>
							</Col>
						</Row>
					</CardFooter>
				</Card>
			</Col>
			{detail.materials && detail.materials.length > 0 && (
				<Col sm="12 order-2">
					<Card>
						<CardHeader>
							<H5>List Materi Course {detail.title}</H5>
						</CardHeader>
						<div>
							<Table className="table-responsive table-bordered">
								<thead className="table-light">
									<tr>
										<th scope="col"><DualListBox data={detail.materials} /></th>
										<th scope="col">{'Judul Materi'}</th>
										<th scope="col">{'Deskripsi Materi'}</th>
										<th scope="col">{'ID'}</th>
										<th colSpan="2" scope="col" className='text-center'>Aksi</th>
										<th scope="col" className='text-center'>
											<Btn
												attrBtn={{
													color: 'link',
													outline: true,
													className: 'btn-sm btn-danger',
													onFocus: () => {
														// console.log(formatCombinedIds, 'formatCombinedIds')
														// console.log(filteredIds, 'filteredIds')
														dispatch(setMaterials(formatCombinedIds));
													},
													onClick: () => {
														console.log('selectedMaterials', selectedMaterials)
														if (selectedMaterials.length > 0 && detail.materials.length === 1) {
															Swal.fire(
																'Gagal!',
																'Course harus memiliki minimal 1 materi.',
																'error'
															)
														} else if (selectedMaterials.length === detail.materials.length) {
															Swal.fire(
																'Gagal!',
																'Course harus memiliki minimal 1 materi.',
																'error'
															)
														} else if (selectedMaterials.length === 0 && detail.materials.length > 1) {
															Swal.fire(
																'Gagal!',
																'Silahkan pilih materi yang akan dihapus.',
																'error'
															)
														} else if (selectedMaterials.length === 0 && detail.materials.length === 1) {
															Swal.fire(
																'Gagal!',
																'Course harus memiliki minimal 1 materi.',
																'error'
															)
														} else if (selectedMaterials.length > 0 && detail.materials.length > 1) {
															handleDetach(detail, data, dispatch, attachDetachCourses, setDetail, selectedMaterials)
														}
													}
												}}
											>Delete
											</Btn>
										</th>
									</tr>
								</thead>
								<tbody>
									{
										detail.materials && detail.materials.map((item, index) =>
											<tr key={`course-${index}`}>
												<th className='text-center'>{index + 1}</th>
												<td>{item.name}</td>
												<td><CleanLimitHTML htmlContent={item.description} limit={40} /></td>
												<td>{item.id}</td>
												<td className='text-center'>
													<Link to={`${process.env.PUBLIC_URL}/learning/materi-detail/${item.id}`}
														onClick={() => handleGetDetailMaterial(dispatch, item, setDetailMateri)}
													>
														<i className="fa fa-info-circle mx-auto fa-lg"></i>
													</Link>
												</td>
												<td className='text-center'>
													<Link to={`${process.env.PUBLIC_URL}/learning/materi-add/${item.id}`}
														onClick={() => handleEditMateri(dispatch, item, setFieldMateri)}
													>
														<i className="fa fa-edit mx-auto text-black fa-lg"></i>
													</Link>
												</td>
												<td className='text-center'>
													<Input className="checkbox_animated" id={`detach-${item.id}`} type="checkbox"
														checked={selectedMaterials.includes(item.id)}
														onChange={() => handleCheckboxChange(item.id)} />

												</td>
											</tr>
										)
									}
								</tbody>
							</Table>
						</div>
					</Card>
				</Col>
			)
			}
		</>
	);
};
export default BoxListCourseDetail;